import { MutationTree } from 'vuex'
import { SidebarState } from './state'
import { EOpenSidebar } from '@/constants/sidebar'

export enum SidebarMutationTypes {
  ToggleSidebar = '[Sidebar Mutation] Toggle',
}

export const mutations: MutationTree<SidebarState> = {
  [SidebarMutationTypes.ToggleSidebar](
    state: SidebarState,
    sidebar: EOpenSidebar | false,
  ) {
    const newOpenSidebar =
      !sidebar || sidebar === state.openSidebar ? false : sidebar

    window.document.body.setAttribute('show-sidebar', `${!!newOpenSidebar}`)
    state.openSidebar = newOpenSidebar
  },
}
